function equalizeCardHeights() {
  const grid = document.querySelector('.product-grid');
  if (!grid) return;

  const titles = Array.from(grid.querySelectorAll('.card__heading'));
  titles.forEach(el => (el.style.height = 'auto'));

  const rows = {};
  titles.forEach(el => {
    const top = el.closest('.product-card-wrapper')?.offsetTop || 0;
    (rows[top] ||= []).push(el);
  });

  Object.values(rows).forEach(group => {
    const max = Math.max(...group.map(el => el.offsetHeight));
    group.forEach(el => (el.style.height = max + 'px'));
  });
}

document.addEventListener('DOMContentLoaded', equalizeCardHeights);
window.addEventListener('resize', equalizeCardHeights);
window.addEventListener('load', equalizeCardHeights);